import { useMutation } from "@apollo/client";
import {
  UpdateClientServiceProfileDocument,
  ClientServiceProfileByFiltersDocument,
  ClientServiceProfileStatusesEnum,
} from "@/__generated__/graphql";
import { useAuthState } from "@/store/auth";

export const useUpdateClientServiceProfileMutation = () => {
  const mutation = useMutation(UpdateClientServiceProfileDocument, {
    refetchQueries: [
      {
        query: ClientServiceProfileByFiltersDocument,
        variables: {
          filters: {
            clientId: useAuthState.getState().data.userInfo.id,
            status: ClientServiceProfileStatusesEnum.Active,
          },
        },
      },
    ],
  });

  return mutation;
};
